import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '../theme/ThemeContext';
import PrimaryButton from '../components/auth/PrimaryButton';

/**
 * AccessDenied Page
 * Shown when user has no valid Cognito groups or tries to access wrong agent
 */
function AccessDenied() {
  const navigate = useNavigate();
  const { theme } = useTheme();

  const handleGoToLogin = () => {
    // Clear any stored session data
    localStorage.clear();
    navigate('/login', { replace: true });
  };

  return (
    <div 
      style={{ 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center', 
        height: '100vh',
        background: theme.auth?.containerBg || '#fff',
        color: theme.auth?.containerText || '#000'
      }}
    >
      <div 
        style={{ 
          maxWidth: 420, 
          margin: '0 auto', 
          padding: 32, 
          border: `1px solid ${theme.auth?.containerBorder || '#ddd'}`, 
          borderRadius: 12, 
          boxShadow: theme.auth?.containerShadow || '0 2px 8px rgba(0,0,0,0.1)',
          background: theme.auth?.containerBg || '#fff',
          textAlign: 'center'
        }}
      >
        <div 
          style={{ 
            fontSize: 48, 
            marginBottom: 16,
            opacity: 0.3
          }}
        >
          🚫
        </div>
        
        <h1 
          style={{ 
            marginTop: 0, 
            marginBottom: 12,
            fontSize: 24
          }}
        >
          Access Denied
        </h1>
        
        <p 
          style={{ 
            fontSize: 14, 
            color: theme.auth?.mutedText || '#666', 
            marginBottom: 24,
            lineHeight: 1.5
          }}
        >
          You do not have permission to access this application. 
          Please contact your administrator to request access.
        </p>

        <PrimaryButton onClick={handleGoToLogin}>
          Return to Login
        </PrimaryButton>
      </div>
    </div>
  );
}

export default AccessDenied;
